import { loadDefaultLanguage } from '@v4/locale/async';
import Header from '@v4/header';

(async () => {
    await loadDefaultLanguage();

    if (document.getElementById('header')) {
        Header();
    }
})();
